module.exports = __webpack_public_path__ + "01_short_brown.9357b6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_short_brown.png
// module id = 6o96
// module chunks = 0